import { Sparkles, Copy, Check } from 'lucide-react';
import { useState, type FC } from 'react';

interface AISuggestion {
  suggestedResponse: string;
  model: string;
  tokensUsed: number;
}

interface AISuggestionBlockProps {
  suggestion: AISuggestion;
}

const AISuggestionBlock: FC<AISuggestionBlockProps> = ({ suggestion }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(suggestion.suggestedResponse);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fc-card border-violet-200 bg-violet-50 p-4 dark:border-violet-800 dark:bg-violet-900/20">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-violet-500 dark:text-violet-400" />
          <span className="text-xs font-medium uppercase tracking-wider text-violet-600 dark:text-violet-400">
            Réponse Suggérée
          </span>
        </div>
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium text-violet-600 hover:bg-violet-100 dark:text-violet-400 dark:hover:bg-violet-800/30 transition-colors"
          title="Copier la suggestion"
        >
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? 'Copié !' : 'Copier'}
        </button>
      </div>
      <p className="mt-2 text-sm leading-relaxed text-violet-800 dark:text-violet-200 whitespace-pre-wrap">
        {suggestion.suggestedResponse}
      </p>
      <div className="mt-2 flex items-center gap-3 text-[10px] text-violet-500 dark:text-violet-500">
        <span>Modèle : {suggestion.model}</span>
        <span>•</span>
        <span>{suggestion.tokensUsed} tokens</span>
      </div>
    </div>
  );
};

export default AISuggestionBlock;
